import { MethodChoiceCard } from "../../MethodChoiceCard";

/**
 * The wizard's first screen (Q1, D-16): "Do you have a race coming up?" Two
 * one-tap answers built on the shared `MethodChoiceCard` nav variant (W-04)
 * with the `--door` sizing modifier (planner.css); picking one advances (no
 * Continue button). Counted in the step progress (D-08).
 */
export function IntentStep({
  onPickRace,
  onPickNoRace
}: {
  /** "Yes" → hasRace true, go to the Race step. */
  onPickRace: () => void;
  /** "Not right now" → hasRace false, race cleared, go to the Method step. */
  onPickNoRace: () => void;
}) {
  return (
    <div className="fgp-wizard-panel" style={{ gap: 12 }}>
      <MethodChoiceCard
        variant="nav"
        className="fgp-wz-methodcard--door"
        icon="flag"
        tone="lime"
        title="Yes, I’m training for a race"
        pill="Most popular"
        desc="Tell us the race — we’ll fuel your training all the way through race day."
        onSelect={onPickRace}
      />
      <MethodChoiceCard
        variant="nav"
        className="fgp-wz-methodcard--door"
        icon="calendar"
        tone="purple"
        title="Not right now, I’m just training"
        desc="No race yet — we’ll fuel the training you do."
        onSelect={onPickNoRace}
      />
    </div>
  );
}
